import { useMemo } from "react";

import { EntityType } from "@mapmycustomers/shared";
import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import { EntityTypeSupportingReports } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";
import tripFieldModel, { TripFieldName } from "@app/util/fieldModel/tripFieldModel";

const useHiddenColumnsFromEntityTypeAndRole = (
  entityType?: EntityTypeSupportingReports,
  isMember?: boolean
): IField[] =>
  useMemo(() => {
    const fields = entityType
      ? getFieldModelByEntityType(entityType).fields.filter(
          (field) =>
            (field.hasFeature(FieldFeature.NON_EXPORT_VIEW) &&
              !field.hasAnyFeature(FieldFeature.VIEW_AS_FIELD, FieldFeature.TEAM_FIELD)) || // making viewAs and team filters available
            // but viewAs is not available for members
            (isMember && field.hasFeature(FieldFeature.VIEW_AS_FIELD))
        )
      : [];

    // temporarily excluding the Classification field from filters, only allowing to see Business trips
    // temporarily excluding the Classification field from filters, only allowing to see Business trips
    if (entityType === EntityType.TRIP) {
      fields.push(tripFieldModel.getByName(TripFieldName.TYPE)!);
    }

    return fields;
  }, [entityType, isMember]);

export default useHiddenColumnsFromEntityTypeAndRole;
